<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Promociones</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div></div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          {{ titulo }}
        </b-col>
      </b-row>

      <b-row>
        <b-col class="mt-3">
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Nombre
                  <validacion>*</validacion>
                </label>
                <b-form-input v-model="$v.promocion.nombre.$model" :state="validateState('nombre') "
                              placeholder="Nombre de promoción"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Tipo promoción
                  <validacion>*</validacion>
                </label>
                <v-select v-model="$v.promocion.idTipoPromocion.$model" :class="selectClass('idTipoPromocion')"
                          :state="validateState('idTipoPromocion')" :options="tipos" :reduce="(val) => val.idTipoPromocion"
                          label="nombre" placeholder="Tipo promoción"></v-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-left">
              <h5>Vigencia</h5>
              <hr />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Fecha inicio
                  <validacion>*</validacion>
                </label>
                <b-form-datepicker v-model="$v.promocion.fechaInicio.$model" :state="validateState('fechaInicio')"
                                   :min="new Date()" placeholder="Fecha inicio"></b-form-datepicker>
                <!--                <b-form-invalid-feedback :state="fecha !=null">-->
                <!--                  Se debe colocar-->
                <!--                </b-form-invalid-feedback>-->
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Fecha fin
                  <validacion>*</validacion>
                </label>
                <b-form-datepicker v-model="$v.promocion.fechaFin.$model" :state="validateState('fechaFin')"
                                   :min="new Date()" placeholder="Fecha fin"></b-form-datepicker>
                <!--                <b-form-invalid-feedback :state="fechaFin !=null">-->
                <!--                  Se debe colocar-->
                <!--                </b-form-invalid-feedback>-->
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-left">
              <h5>Clínicas</h5>
              <hr />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Regiones
                  <validacion>*</validacion>
                </label>
                <v-select v-model="zona" :options="zonas" label="nombreZona" @input="cambioZona($event)"
                          placeholder="Regiones"></v-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-card class="txSesion" v-for="(z, i) in zonasSelecionadas" :key="'z' + i">
                <b-row>
                  <b-col class="text-left">
                    {{ z.nombreZona }}
                  </b-col>
                  <b-col class="text-right">
                    <b-button variant="danger" @click="eliminarZona(z)" size="sm"><em class="fa fa-close"></em>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Clínicas
                  <validacion>*</validacion>
                </label>
                <v-select multiple v-model="$v.promocion.clinicas.$model" :class="selectClass('clinicas')"
                          :state="validateState('clinicas')" :options="clinicas" :reduce="(val) => val.idClinica"
                          label="strNombre" placeholder="Clínicas"></v-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-left">
              <h5>Atributos del paciente</h5>
              <hr />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Subtipo de paciente
                  <validacion>*</validacion>
                </label>  
                <b-form-select
                          placeholder="Seleccione el subtipo de paciente"
                          v-model="promocion.subtiposPaciente"
                          :options="subtiposPaciente"
                          :class="selectClass('subtiposPaciente')"
                          value-field="id"
                          text-field="descripcion"   
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Tipo de paciente 
                  <validacion>*</validacion>
                </label>
                          <b-form-select
                          placeholder="Selecciona el tipo paciente"
                          v-model="promocion.tiposPaciente"
                          :options="tiposPaciente"
                          value-field="id"
                          text-field="descripcion"   
                          :class="selectClass('tiposPaciente')"
                      ></b-form-select>
              </b-form-group>
              
            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-left">
              <h5>Tratamientos</h5>
              <hr />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Tratamientos
                  <validacion>*</validacion>
                </label>
                <!--                <v-select :options="tratameintos" v-model="tratamientos" @input="agregarTratameinto($event)" label="nombre" :state="tratamientos != null"-->
                <!--                         ></v-select>-->
                <v-select :options="tratameintos" @input="agregarTratameinto($event)" label="nombre"
                          placeholder="Seleccion de tratamientos para aplicar en los descuentos de zonas"></v-select>

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card class="txSesion" v-for="(t, i) in promocion.tratamientos" :key="'tx' + i">
                <b-row>
                  <b-col class="text-left">
                    {{ t.nombre }}
                  </b-col>
                  <b-col class="text-right">
                    <b-button variant="danger" @click="eliminarTratamiento(t)" size="sm"><em class="fa fa-close"></em>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="promocion.idTipoPromocion === 3">
              <b-form-group align="left">
                <label>Tratamientos con descuento preferencial
                  <validacion>*</validacion>
                </label>
                <v-select @input="agregarTratamientoPromocion($event)" :options="tratameintos" label="nombre"
                          placeholder="Tratamientos"
                          :disabled="promocion.tratamientos <= 0 && promocion.idTipoPromocion == 3
                          || promocion.tratamientos <= 0 && promocion.idTipoPromocion == 2"></v-select>
              </b-form-group>
            </b-col>
            <b-col v-if="promocion.idTipoPromocion === 2">
              <b-form-group align="left">
                <label>Tratamientos de regalo
                  <validacion>*</validacion>
                </label>
                <v-select :options="tratameintos" @input="agregarTratamientoPromocion($event)" label="nombre"
                          placeholder="Tratamientos"></v-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="promocion.txPromocion.length> 0">
            <b-col>





              <b-table  thead-tr-class="columnas"
                        v-if="$v.promocion.idTipoPromocion.$model === 3 && this.$route.params.idPromocion == '0'"
                        :items="promocion.txPromocion" :fields="columnasTx" class="parrafos" small lazy>
                <template v-slot:head(zonas)="row">
                  <div class="text-center">
                    <span>Zonas monto</span>
                    <b-form v-if="promocion.idTipoPromocion !== 2" inline>
                      <div class="mr-3" v-for="(z, i) in zonas" :key="'tzh-' + i">
                        <label style="font-size: small">{{
                            z.nombreZona
                          }}</label>
                        <b-form-input maxlength="5" v-model="z.dato" @keypress="onlyNumber($event)" :disabled="promocion.idTipoPromocion === 3"
                                      @input="porcentajeZona4(z,$event )" class="form-control-sm" style="width: 5vw"></b-form-input>
                      </div>
                    </b-form>
                  </div>
                </template>
                <template v-slot:cell(nombre)="row">
                  <div class="text-left">
                    {{ row.item.nombre }}
                  </div>
                </template>
                <template v-slot:cell(zonas)="row">
                  <b-form inline>

                    <div class="mr-3" v-for="(z, i) in row.item.zonas" :key="'tz-' + i">
                      <label style="font-size: small">{{
                          Math.round(z.descuento)+ '%'
                        }}</label>
                      <label style="font-size: small">{{ z.nombreZona }}</label>
                      <b-form-input maxlength="5" @keypress="onlyNumber($event)"
                                    @input="porcentajeZona5(z,row.item,$event)" v-model="z.precio" class="form-control-sm"
                                    style="width: 5vw">
                      </b-form-input>
                    </div>
                  </b-form>
                </template>
                <template v-slot:cell(Eliminar)="row">
                  <b-button size="sm" variant="danger" @click="eliminarTratamientos(row.item)"><em
                      class="fa fa-close"></em></b-button>
                </template>
              </b-table>







              <b-table thead-tr-class="columnas"
                       v-else-if="$v.promocion.idTipoPromocion.$model === 3 && this.$route.params.idPromocion != '0'"
                       :items="promocion.txPromocion" :fields="columnasTx" class="parrafos" small lazy>
                <template v-slot:head(zonas)="row">
                  <div class="text-center">
                    <span>Zonas monto</span>
                    <b-form v-if="promocion.idTipoPromocion !== 2" inline>
                      <div class="mr-3" v-for="(z, i) in zonas" :key="'tzh-' + i">
                        <label style="font-size: small">{{
                            z.nombreZona
                          }}</label>
                        <b-form-input maxlength="5" v-model="z.precio" @keypress="onlyNumber($event)" :disabled="promocion.idTipoPromocion === 3"
                                      @input="porcentajeZona3(z)" class="form-control-sm" style="width: 5vw"></b-form-input>
                      </div>
                    </b-form>
                  </div>
                </template>
                <template v-slot:cell(nombre)="row">
                  <div class="text-left">
                    {{ row.item.nombre }}
                  </div>
                </template>
                <template v-slot:cell(zonas)="row">
                  <b-form inline>
                    <div class="mr-3" v-for="(z, i) in row.item.zonas" :key="'tz-' + i">
                      <label style="font-size: small">{{
                          "%" + z != undefined
                              ?
                              (Math.round((z.descuento + Number.EPSILON) * 100) /
                                  100 )+"%"
                              : ""
                        }}</label>
                      <label style="font-size: small">{{ z.nombreZona }}</label>
                      <b-form-input maxlength="5" :disabled="promocion.idTipoPromocion === 2"
                                    @keypress="onlyNumber($event)" @input="porcentajeZona2(z, row.item)" v-model="z.precio"
                                    class="form-control-sm" style="width: 5vw">
                      </b-form-input>
                    </div>
                  </b-form>
                </template>
                <template v-slot:cell(Eliminar)="row">
                  <b-button size="sm" variant="danger" @click="eliminarTratamientos(row.item)"><em
                      class="fa fa-close"></em></b-button>
                </template>
              </b-table>



              <b-table thead-tr-class="columnas" v-else :items="promocion.txPromocion" :fields="columnasTx"
                       class="parrafos" small lazy>
                <template v-slot:head(zonas)="row">
                  <div class="text-center">
                    <span>Zonas descuento</span>
                    <b-form v-if="promocion.idTipoPromocion !== 2" inline>
                      <div class="mr-3" v-for="(z, i) in zonas" :key="'tzh-' + i">
                        <b-form-input maxlength="3" v-model="z.dato" @keypress="onlyNumber($event)"
                                      @input="porcentajeZona(z)" class="form-control-sm" style="width: 5vw"></b-form-input>
                      </div>
                    </b-form>
                  </div>
                </template>
                <template v-slot:cell(nombre)="row">
                  <div class="text-left">
                    {{ row.item.nombre }}
                  </div>
                </template>
                <template v-slot:cell(zonas)="row">
                  <b-form inline>
                    <div class="mr-3" v-for="(z, i) in row.item.zonas" :key="'tz-' + i">
                      <label style="font-size: small">{{ z.nombreZona }}</label>
                      <b-form-input maxlength="3" :disabled="promocion.idTipoPromocion === 2"
                                    @keypress="onlyNumber($event)" @input="mayorCien(z, $event)" v-model="z.descuento"
                                    class="form-control-sm" style="width: 5vw">
                      </b-form-input>
                    </div>
                  </b-form>
                </template>
                <template v-slot:cell(Eliminar)="row">
                  <b-button size="sm" variant="danger" @click="eliminarTratamientos(row.item)"><em
                      class="fa fa-close"></em></b-button>
                </template>
              </b-table>




            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-left">
              <hr />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>¿Aplica para otras promociones?</label>
                <b-form-checkbox v-model="$v.promocion.aplicaOtrasPromociones.$model"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>¿La promocion es forzosa?</label>
                <b-form-checkbox v-model="$v.promocion.promocionForzosa.$model"></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="secondary" :disabled="loader" @click="cancelar()">Cancelar</b-button>
          <b-button variant="primary" :disabled="loader" @click="guardar"><span v-if="!loader">Guardar</span>
            <span v-if="loader">
              <b-spinner small></b-spinner>
              Cargando...
            </span></b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {
  CatalogosService
} from "../../apiServices/catalogos/CatalogosService";
import {
  TratamientoService
} from "../../apiServices/tratamiento/TratamientoService";
import {
  required
} from "vuelidate/lib/validators";
import {
  PromocionesService
} from "../../apiServices/promociones/PromocionesService";
import Swal from "sweetalert2";

export default {
  catalogosService: new CatalogosService(),
  tratamientoService: new TratamientoService(),
  promocionesServicio: new PromocionesService(),
  name: "formularioPromociones",
  components: {
    Header,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      fecha:null,
      fechaFin:null,
      tratamientos:null,
      loader: false,
      idPromocion: null,
      titulo: "Agregar Promoción",

      clinicas: [],
      tiposPaciente: [],
      subtiposPaciente: [],
      tratameintos: [],
      tipos: [],
      zonas: [],
      especialidades: [],

      promocion: {
        idPromocion: null,
        nombre: null,
        idTipoPromocion: null,
        fechaInicio: null,
        fechaFin: null,
        clinicas: [],
        tratamientos: [],
        descuento: null,
        txPromocion: [],
        bonificacion: null,
        aplicaOtrasPromociones: false,
        tiposPaciente: [],
        subtiposPaciente: [],
        promocionForzosa: false,
      },

      especialidad: null,
      zona: null,
      zonasSelecionadas: [],

      tx: null,

      columnasTx: [{
        key: "nombre",
        label: "Tratamiento",
        thClass: "w-50",
      },
        {
          key: "zonas",
          label: "Zonas",
        },
        "Eliminar",
      ],
    };
  },
  validations() {
    if (this.promocion.idTipoPromocion !== null) {
      switch (this.promocion.idTipoPromocion) {
        case 1:
          return {
            promocion: {
              idPromocion: {},
              nombre: {
                required,
              },
              tiposPaciente: {
                required,
              },
              subtiposPaciente: {
                required,
              },
              idTipoPromocion: {
                required,
              },
              fechaInicio: {
                required,
              },
              fechaFin: {
                required,
              },
              clinicas: {
                required,
              },
              txPromocion: {
                required,
              },
              aplicaOtrasPromociones: {
                required,
              },
              promocionForzosa: {
                required,
              },
            },
          };
        case 2:
          return {
            promocion: {
              idPromocion: {},
              nombre: {
                required,
              },
              tiposPaciente: {
                required,
              },
              subtiposPaciente: {
                required,
              },
              idTipoPromocion: {
                required,
              },
              fechaInicio: {
                required,
              },
              fechaFin: {
                required,
              },
              clinicas: {
                required,
              },
              tratamientos: {
                required,
              },
              txPromocion: {
                required,
              },
              aplicaOtrasPromociones: {
                required,
              },
              promocionForzosa: {
                required,
              },
            },
          };
        case 3:
          return {
            promocion: {
              idPromocion: {},
              nombre: {
                required,
              },
              tiposPaciente: {
                required,
              },
              subtiposPaciente: {
                required,
              },
              idTipoPromocion: {
                required,
              },
              fechaInicio: {
                required,
              },
              fechaFin: {
                required,
              },
              clinicas: {
                required,
              },
              tratamientos: {
                required,
              },
              txPromocion: {
                required,
              },
              aplicaOtrasPromociones: {
                required,
              },
              promocionForzosa: {
                required,
              },
            },
          };
        case 4:
          return {
            promocion: {
              idPromocion: {},
              nombre: {
                required,
              },
              tiposPaciente: {
                required,
              },
              subtiposPaciente: {
                required,
              },
              idTipoPromocion: {
                required,
              },
              fechaInicio: {
                required,
              },
              fechaFin: {
                required,
              },
              clinicas: {
                required,
              },
              txPromocion: {
                required,
              },
              aplicaOtrasPromociones: {
                required,
              },
              promocionForzosa: {
                required,
              },
            },
          };
      }
    } else {
      return {
        promocion: {
          idPromocion: {},
          nombre: {
            required,
          },
          tiposPaciente: {
            required,
          },
          subtiposPaciente: {
            required,
          },
          idTipoPromocion: {
            required,
          },
          fechaInicio: {
            required,
          },
          fechaFin: {
            required,
          },
          clinicas: {
            required,
          },
          tratamientos: {
            required,
          },
          aplicaOtrasPromociones: {
            required,
          },
          promocionForzosa: {
                required,
              },
        },
      };
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    if (parseInt(this.$route.params.idPromocion) !== 0) {
      this.titulo = "Editar Promoción";
      this.idPromocion = this.$route.params.idPromocion;
      this.obtenerDatosPorID();
    }
    this.catalogos();
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    mayorCien(z, event) {
      z.datoI = event;
      if (parseInt(z.datoI) > 100) {
        z.datoI = "100";
      }
      z.descuento = z.datoI;
    },
    mayorCien2(z, event) {
      z.datoI = event;
      z.descuento = z.datoI;
    },
    catalogos() {
      this.obtenerClinicas();
      this.obtenerTipoPaciente();
      this.obtenerSubTipoPaciente();
      this.obtenerTratamientos();
      this.obtenerTipodePromocion();
      this.obtenerZonas();
      this.obtenerEspecialidades();
    },
    obtenerClinicas() {
      this.$options.catalogosService.listaClinicas().then((response) => {
        this.clinicas = response;
      });
    },
    obtenerTipoPaciente() {
      this.$options.catalogosService.obtenerTipoPaciente().then((response) => {
        this.tiposPaciente = response.data;
        this.tiposPaciente.unshift({id: 0, descripcion: 'Todos'})
      });
    },

    obtenerSubTipoPaciente() {
      this.$options.catalogosService.obtenerSubTipoPaciente().then((response) => {
        this.subtiposPaciente = response.data;
        this.subtiposPaciente.unshift({id: 0, descripcion: 'Todos'})
      });
    },
    obtenerTratamientos() {
      this.$options.catalogosService
          .obtenerTratamientosConEspecilidades()
          .then((response) => {
            this.tratameintos = response;
          });
    },
    obtenerTipodePromocion() {
      this.$options.catalogosService.listaTiposPromocion().then((response) => {
        this.tipos = response;
      });
    },
    actualizar3() {
      this.promocion.txPromocion.map((t) => {
        t.zonas.map((z2) => {
          z2.descuento = "" + z2.descuento;
        });
      });
    },
    obtenerZonas() {
      this.$options.catalogosService.listaZonas().then((response) => {
        this.zonas = response.map((z) => {
          z.dato = 0;
          z.datoI = 0;
          return z;
        });
      });
    },
    obtenerEspecialidades() {
      this.$options.catalogosService
          .obtenerEspecialidades()
          .then((response) => {
            this.especialidades = response;
          });
    },
    obtenerDatosPorID() {
      this.$options.promocionesServicio
          .obtenerPorId(this.idPromocion)
          .then((response) => {
            this.promocion = response;
            this.promocion.subtiposPaciente = this.promocion.subtiposPaciente == null ? 0 : this.promocion.subtiposPaciente
            this.promocion.tiposPaciente = this.promocion.tiposPaciente == null ? 0 : this.promocion.tiposPaciente
            
            response.txPromocion.forEach((element) => {
              element.zonas.forEach((element2) => {
                const parametros = {idTratamiento: element.idTratamiento}
                this.$http.post(
                    this.$api +
                    "tratamientos/preciosTratamiento", parametros
                )
                    .then((response) => {
            
                      if (response.data.success) {


                        response.data.data.zonaPrecios.forEach((element3) => {

                          if (element3.idPrecio === element2.idPrecio && element3.idTratamiento ===
                              element.idTratamiento) {

                            var descuento = (element2.descuento / 100);
                            descuento = 1 - descuento;
                            var calculo = element3.precio * descuento;
                            element2.precio = Math.round(calculo);
                          }


                        })

                      }



                    });

              });
            });
          });
    },

    guardar() {
      this.$v.$touch()
      if (this.$v.$invalid || this.zonas.length == 0 ||  this.promocion.fechaInicio == null || this.promocion.fechaFin == null ) {
        Swal.fire({
          title: "Verifique los campos obligatorios",
        });
        return false;
      }

      this.loader = true;
      this.$options.promocionesServicio
          .guardarPromocion(this.promocion)
          .then((respuesta) => {
            if (respuesta) {
              const text =
                  this.promocion.idPromocion !== null ?
                      "Promocion actualizada" :
                      "Promocion guardada exitosamente";

              this.$swal({
                icon: "success",
                text: text,
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
                onClose: () => {
                  this.cancelar();
                },
              });
            }
          });

      //}
    },

    cambioZona(e) {
      if (!this.zonasSelecionadas.includes(e)) {
        this.zonasSelecionadas.push(e);
      }

      const clin = this.clinicas
          .filter((c) => c.idPrecio === e.idPrecio)
          .map((c) => c.idClinica);
      clin.map((c) => {
        if (!this.promocion.clinicas.includes(c)) {
          this.promocion.clinicas.push(c);
        }
      });

      this.zona = null;
    },
    eliminarZona(e) {
      const ids = this.clinicas
          .filter((c) => c.idPrecio === e.idPrecio)
          .map((c) => c.idClinica);
      this.zonasSelecionadas.splice(this.zonasSelecionadas.indexOf(e), 1);
      this.promocion.clinicas = this.promocion.clinicas.filter(
          (c) => !ids.includes(c)
      );
    },

    agregarTratameinto(e) {
      if (
          this.promocion.idTipoPromocion === 1 ||
          this.promocion.idTipoPromocion === 4
      ) {
        this.agregarTratamientoPromocion(e);
      } else {
        if (!this.promocion.tratamientos.includes(e)) {
          this.promocion.tratamientos.push(e);
        }
      }
    },
    agregarTratamientoPromocion(e) {
      const tipoPromo = this.promocion.idTipoPromocion
      if(tipoPromo == 2 && this.promocion.tratamientos.length <= 0 || tipoPromo == 3 && this.promocion.tratamientos.length <= 0) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Debe seleccionar un tratamiento base",
        });
      }else {
        if (!this.promocion.txPromocion.includes(e)) {
          e.zonas = this.zonas.map((z) => {
            z.descuento = 0;
            if (this.promocion.idTipoPromocion === 2) {
              z.descuento = 100;
            }
            return JSON.parse(JSON.stringify(z));
          });

          this.promocion.txPromocion.push(e);
        }
      }


    },

    eliminarTratamientos(e) {
      this.promocion.txPromocion.splice(
          this.promocion.txPromocion.indexOf(e),
          1
      );
    },
    eliminarMuchosTratamientos() {
      this.promocion.txPromocion.splice(this.promocion.txPromocion);
    },
    eliminarTratamiento(e) {
      if (this.promocion.tratamientos.length == 1){
        this.eliminarMuchosTratamientos(e);
      }
      this.promocion.tratamientos.splice(
          this.promocion.tratamientos.indexOf(e),
          1
      );

    },

    porcentajeZona(zona) {
      if (parseInt(zona.dato) > 100) {
        zona.dato = 100;
      }
      this.promocion.txPromocion.map((t) => {
        t.zonas.map((z) => {
          if (z.idPrecio === zona.idPrecio) {
            z.descuento = zona.dato;
          }
        });
      });
    },

    porcentajeZona4(zona, evento) {
      this.promocion.txPromocion=  this.promocion.txPromocion.map((t) => {
        t.zonas.map((z) => {
          if (z.idPrecio === zona.idPrecio) {

            this.porcentajeZona5(z, t, evento);

          }
          return z;
        });
        return t;
      });
    },
    porcentajeZona6(zona, tramiento) {
      this.promocion.txPromocion = this.promocion.txPromocion.map((t) => {
        t.zonas.map((z) => {
          if (t.idTratamiento == tramiento.idTratamiento) {
            if (z.idPrecio === zona.idPrecio) {
              z.descuento = zona.descuento;
            }
          }
          return z;
        });
        return t;
      });
    },
    porcentajeZona5(zona, tratamiento, evento) {
      const parametros = {idTratamiento: tratamiento.idTratamiento}
      this.$http.post(
          this.$api +
          "tratamientos/preciosTratamiento", parametros
      )
          .then((response) => {
            if (response.data.success) {
              var tramiento = response.data.data;
              if (tramiento.idTratamiento == tratamiento.idTratamiento) {
                response.data.data.zonaPrecios.forEach((element3) => {
                  var calculo = 100 - (evento * 100) / element3.precio;
                  if (calculo > 0) {
                    zona.descuento = calculo;
                  } else {
                    if (!calculo >= 0) {
                      zona.descuento = 0;
                    } else {
                      zona.descuento = 100;
                    }

                  }
                  this.porcentajeZona6(zona, tramiento);
                })
              }
            }
          });
    },
    porcentajeZona3(zona) {
      this.promocion.txPromocion.map((t) => {
        t.zonas.map((z) => {
          if (z.idPrecio === zona.idPrecio) {
            z.descuento = zona.precio;
            this.porcentajeZona2(zona, null);
          }
        });
      });
    },

    porcentajeZona2(zona, promocion) {
      var calculo = 0;
      const parametros = {idTratamiento: promocion.idTratamiento}
      this.$http
          .post(
              this.$api +
              "tratamientos/preciosTratamiento", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              let element = response.data.data;
              element.zonaPrecios.forEach((z2) => {
                if (z2.idPrecio === zona.idPrecio) {
                  calculo = 100 - (zona.precio * 100) / z2.precio;

                  promocion.zonas.map((z) => {
                    if (z.idPrecio === zona.idPrecio) {
                      if (calculo > 0) {
                        z.descuento = calculo;
                      } else {
                        if (!calculo >= 0) {
                          z.descuento = 0;
                        } else {
                          z.descuento = 100;
                        }

                      }
                      this.porcentajeZona6(z, promocion);

                    }
                  });
                }
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });

    },
    cancelar() {
      this.$router.push({
        name: "promociones",
      });
    },
    porcentajeZonaRealTime(zona, tratamiento) {
      this.promocion.txPromocion.map((t) => {
        if (tratamiento.idTratamiento === t.idTratamiento) {
          t.zonas.map((z) => {
            if (z.idPrecio === zona.idPrecio) {
              z.descuento = zona.descuento;
            }
          });

        }

      });
    },

    validateState(name) {
      const {
        $dirty,
        $error
      } = this.$v.promocion[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.txSesion>.card-body {
  font-size: small !important;
  padding: 0.5rem !important;
}
</style>
